"use strict";
/**
 * This code was AUTOGENERATED using the kinobi library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun kinobi to update it.
 *
 * @see https://github.com/metaplex-foundation/kinobi
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRevokeArgsSerializer = exports.RevokeArgs = void 0;
const serializers_1 = require("@metaplex-foundation/umi/serializers");
var RevokeArgs;
(function (RevokeArgs) {
    RevokeArgs[RevokeArgs["CollectionV1"] = 0] = "CollectionV1";
    RevokeArgs[RevokeArgs["SaleV1"] = 1] = "SaleV1";
    RevokeArgs[RevokeArgs["TransferV1"] = 2] = "TransferV1";
    RevokeArgs[RevokeArgs["DataV1"] = 3] = "DataV1";
    RevokeArgs[RevokeArgs["UtilityV1"] = 4] = "UtilityV1";
    RevokeArgs[RevokeArgs["StakingV1"] = 5] = "StakingV1";
    RevokeArgs[RevokeArgs["StandardV1"] = 6] = "StandardV1";
    RevokeArgs[RevokeArgs["LockedTransferV1"] = 7] = "LockedTransferV1";
    RevokeArgs[RevokeArgs["ProgrammableConfigV1"] = 8] = "ProgrammableConfigV1";
    RevokeArgs[RevokeArgs["MigrationV1"] = 9] = "MigrationV1";
    RevokeArgs[RevokeArgs["AuthorityItemV1"] = 10] = "AuthorityItemV1";
    RevokeArgs[RevokeArgs["DataItemV1"] = 11] = "DataItemV1";
    RevokeArgs[RevokeArgs["CollectionItemV1"] = 12] = "CollectionItemV1";
    RevokeArgs[RevokeArgs["ProgrammableConfigItemV1"] = 13] = "ProgrammableConfigItemV1";
    RevokeArgs[RevokeArgs["PrintDelegateV1"] = 14] = "PrintDelegateV1";
})(RevokeArgs = exports.RevokeArgs || (exports.RevokeArgs = {}));
function getRevokeArgsSerializer() {
    return (0, serializers_1.scalarEnum)(RevokeArgs, {
        description: 'RevokeArgs',
    });
}
exports.getRevokeArgsSerializer = getRevokeArgsSerializer;
//# sourceMappingURL=revokeArgs.js.map